import { z } from "zod";

export const ImageGalleryTopicSchema = z.object({
  topRightImageDesktop: z.string(),
  topRightImageTablet: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ""),
  topRightImageMobile: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ""),
  bottomLeftImageDesktop: z.string(),
  bottomLeftImageTablet: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ""),
  bottomLeftImageMobile: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ""),
  title: z.string(),
  subtitle: z.string(),
  descriptiveText: z.string(),
  ctaText: z.string(),
  ctaLink: z.string(),
});
